import script from "./JoinWithAccount.vue?vue&type=script&lang=ts&setup=true"
export * from "./JoinWithAccount.vue?vue&type=script&lang=ts&setup=true"

import "./JoinWithAccount.vue?vue&type=style&index=0&id=6e4bacb0&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2780876773/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e4bacb0"]])

export default __exports__